/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lar-change': {
    width: 24.082,
    height: 20,
    viewBox: '0 0 1233 1024',
    data: '<path pid="0" d="M138.807 600.356l991.609.233a38.21 38.21 0 0127.031 11.186l64.47 64.315c24.158 24.08 7.07 65.403-27.03 65.403H489.202c-32.934 0-50.49 38.76-28.818 63.539l136.01 155.43c21.672 24.778 4.118 63.538-28.817 63.538h-110.61c-10.72 0-20.973-4.505-28.197-12.428L110.533 664.516c-22.526-24.545-5.05-64.16 28.274-64.16zM1094.452 423.8l-991.61-.233a38.216 38.216 0 01-27.03-11.185L11.34 347.91c-24.158-24.08-7.069-65.403 27.03-65.403h705.685c32.935 0 50.49-38.76 28.818-63.539l-136.01-155.43C615.192 38.76 632.747 0 665.682 0h110.61c10.72 0 20.972 4.505 28.196 12.428l318.16 347.056c22.526 24.545 5.05 64.16-28.274 64.16z" _fill="#feffff"/>'
  }
})
